import { PackagingType } from "../../../../../config/enums/PackagingType.enum";

export interface PackagingLevelBaseConfig {
  packagingType: PackagingType;
  dataKey: string;
  unitSizesKey: keyof PackagingDataKeys;
  totalWeightKey: keyof PackagingDataKeys;
  changeUnitsType: string;
  includeWeightUnit?: boolean;
  includePallet?: boolean;
}

interface PackagingDataKeys {
  unitSize: number;
  numberOfBaseUnits: number;
  numberOfPacks: number;
  numberOfCases: number;
  palletWidth: number;
  palletLength: number;
  totalWeightBaseUnit: number;
  totalWeightSalesOfPack: number;
  totalWeightBulkPack: number;
  totalWeightTransportUnitPack: number;
  singleUnitPackaging: unknown[];
  salesUnitPackaging: unknown[];
  bulkUnitPackaging: unknown[];
  transportUnitPackaging: unknown[];
  packagingMethod: unknown[];
  packagingName: string;
  unitSizeWeightUnit: number;
}

export const PACKAGING_LEVELS_CONFIG: PackagingLevelBaseConfig[] = [
  {
    packagingType: PackagingType.SINGLE_UNIT_PACKAGING,
    dataKey: "singleUnitPackaging",
    unitSizesKey: "unitSize",
    totalWeightKey: "totalWeightBaseUnit",
    changeUnitsType: "unitSize",
    includeWeightUnit: true
  },
  {
    packagingType: PackagingType.SALES_UNIT_PACKAGING,
    dataKey: "salesUnitPackaging",
    unitSizesKey: "numberOfBaseUnits",
    totalWeightKey: "totalWeightSalesOfPack",
    changeUnitsType: "numberOfBaseUnits"
  },
  {
    packagingType: PackagingType.BULK_UNIT_PACKAGING,
    dataKey: "bulkUnitPackaging",
    unitSizesKey: "numberOfPacks",
    totalWeightKey: "totalWeightBulkPack",
    changeUnitsType: "numberOfPacks"
  },
  {
    packagingType: PackagingType.TRANSPORT_UNIT_PACKAGING,
    dataKey: "transportUnitPackaging",
    unitSizesKey: "numberOfCases",
    totalWeightKey: "totalWeightTransportUnitPack",
    changeUnitsType: "numberOfCases",
    includePallet: true
  }
];
